"use client";

import Translations from "@translate/components/EmailLogin/shared/VerifyCodeButton";
import React from "react";
import { cn } from "utils";
import { LoadingButton } from "../LoadingButton";
import { I18nUtil } from "@utils/i18n";
import type { EmailLoginVariant } from "../types";
import type { EmailCodeSubmitTrigger } from "@features/auth/authTracking";

const I18n = I18nUtil.createScoped(Translations);

interface VerifyCodeButtonProps {
  variant: EmailLoginVariant;
  canVerify: boolean;
  verifying: boolean;
  onVerify: (trigger: EmailCodeSubmitTrigger) => void;
  className?: string;
  /** V3 flat VerifyEmail — static Figma shows full-teal CTA even when code incomplete. */
  forceEnabledAppearance?: boolean;
}

export function VerifyCodeButton({
  variant,
  canVerify,
  verifying,
  onVerify,
  className,
  forceEnabledAppearance = false,
}: VerifyCodeButtonProps) {
  const showEnabled = forceEnabledAppearance || canVerify;
  return (
    <LoadingButton
      data-testid="verify-email-cta"
      data-openreplay-label="login_emaillogincodeverifystep_click"
      type="button"
      disabled={!canVerify}
      loading={verifying}
      onClick={() => onVerify("button")}
      className={cn(
        "button_l flex h-12 w-full items-center justify-center rounded-lg transition-opacity",
        variant === "desktop" && "mt-[85px] md:mt-[48px]",
        variant === "popup" && "mt-12 md:mt-[48px]",
        variant === "mobile" && "",
        variant === "desktop" || variant === "popup"
          ? showEnabled
            ? "bg-background_white_overlay100 text-content_inverse_primary"
            : "cursor-not-allowed bg-background_white_overlay20 text-content_inverse_primary"
          : showEnabled
            ? "bg-background_brand_overlay100 text-content_inverse_primary"
            : "cursor-not-allowed bg-background_brand_overlay70 text-content_inverse_primary",
        className,
      )}
    >
      {I18n.t("Verify")}
    </LoadingButton>
  );
}
